export type ExecutorStatus = 'new' | 'blocked' | 'removed';

export const executorStatusType: Record<ExecutorStatus, string> = {
  new: 'ic-status_blue',
  blocked: 'ic-status_red',
  removed: 'ic-status_red',
};
export const executorStatusClr: Record<ExecutorStatus, string> = {
  new: 'status-clr_blue',
  blocked: 'status-clr_red',
  removed: 'status-clr_red',
};
